import { z } from "zod";

import { looseArray } from "../looseParse";

// FPSL money/quantity values come from the broker backend, which serializes
// decimals as strings. These loans go through `looseArray`, so a string here
// would silently drop the whole loan row — coerce (accepts numbers unchanged,
// keeps the `number` type consumers format/sum). No live loan data to confirm.
export const secfiLoanInterestSchema = z.object({
  customer: z.coerce.number().nullish(),
  partner: z.coerce.number().nullish(),
});

export const secfiLoanSchema = z.object({
  date: z.string(),
  account_id: z.string(),
  account_number: z.string(),
  correspondent: z.string(),
  symbol: z.string(),
  quantity: z.coerce.number(),
  market_value: z.coerce.number(),
  collateral: z.coerce.number(),
  updated_at: z.string().optional(),
  interest: secfiLoanInterestSchema.optional(),
});

export const getSecfiLoansResponseSchema = z.object({
  // Per-item: one malformed loan must not wipe the whole page (the previous
  // `z.array(...).catch([])` silently discarded every loan on a single bad row).
  loans: looseArray(secfiLoanSchema, "getSecfiLoansResponseSchema.loans"),
  next_page_token: z.string().nullable(),
});

export const secfiLoanAnalyticsInterestSchema = z.object({
  customer: z.coerce.number().nullish(),
  partner: z.coerce.number().nullish(),
});

export const secfiLoanAnalyticsSchema = z.object({
  account_number: z.string(),
  interest: secfiLoanAnalyticsInterestSchema,
  total_lending_activities: z.number(),
  in_progress_lending_activities: z.number().optional(),
});
